import { createSlice } from '@reduxjs/toolkit';
import { IAction } from "../actionTypes";
import { IProductInfo } from "@protoplan/types";
import { TBrand } from '../../types/product';

export type IProductsState = {
  products: IProductInfo[] | undefined,
  brands: TBrand[]
};

export const productsSlice = createSlice({
  name: 'products',
  initialState:
  {
    products: undefined,
    brands: <TBrand[]>[]
  },
  reducers: {
    updateProducts: (state: IProductsState, action: IAction<IProductInfo[] | undefined>) =>
    {
      state.products = action.payload;
    },
    removeProduct: (state: IProductsState, action: IAction<number>) =>
    {
      state.products = state.products?.filter(product => product.productId !== action.payload);
    },
    updateBrands: (state: IProductsState, action: IAction<TBrand[]>) =>
    {
      state.brands = action.payload;
    }
  }
});

export const {
  updateProducts,
  removeProduct,
  updateBrands } = productsSlice.actions;

export default productsSlice.reducer;
